import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import './PersianBookCard.css';

function PersianBookCard({ _id, title, author, categories, image_url }) {
    const [bookStatus, setBookStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);

    // دریافت اطلاعات کاربر از localStorage
    useEffect(() => {
        const userData = localStorage.getItem('currentUser');
        console.log("User data from localStorage:", userData); // برای دیباگ
        
        if (userData) {
            try {
                const user = JSON.parse(userData);
                setCurrentUser(user);
                setIsAdmin(user.role === 'admin');
                console.log("User role:", user.role); // برای دیباگ
            } catch (e) {
                console.error("Error parsing user:", e);
            }
        } else {
            console.log("No user logged in");
        }
    }, []);

    // بررسی وضعیت کتاب در لیست کاربر
    useEffect(() => {
        const checkStatus = async () => {
            if (currentUser && !isAdmin && _id) {
                try {
                    console.log("Checking status for book:", _id);
                    const response = await axios.get(`${process.env.REACT_APP_API_URL}/user-book/status/${currentUser._id}/${_id}`);
                    console.log("Book status response:", response.data);
                    setBookStatus(response.data.status);
                } catch (error) {
                    console.error("Error checking book status:", error);
                    setBookStatus(null);
                }
            }
        };
        
        if (currentUser && !isAdmin && _id) {
            checkStatus();
        }
    }, [_id, currentUser, isAdmin]);

    // تابع حذف کتاب (فقط ادمین)
    const handleDelete = async (id) => {
        if (window.confirm('آیا از حذف این کتاب مطمئن هستید؟')) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_URL}/persian-book/${id}`);
                toast.success('کتاب با موفقیت حذف شد!');
                setTimeout(() => window.location.reload(), 1000);
            } catch (error) {
                console.error("Error deleting book:", error);
                toast.error('خطا در حذف کتاب');
            }
        }
    };

    // تابع افزودن/حذف از لیست مطالعه
    const handleToggleStudying = async () => {
        if (isLoading) return;
        setIsLoading(true);
        
        if (!currentUser) {
            toast.error('لطفاً ابتدا وارد شوید');
            window.location.href = '/login';
            return;
        }
        
        try {
            console.log("Toggling studying for book:", _id);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/user-book/studying`, {
                userId: currentUser._id,
                bookId: _id,
                bookType: 'persian'
            });
            
            console.log("Response:", response.data);
            
            if (response.data.action === 'added') {
                setBookStatus('studying');
                toast.success('کتاب به لیست مطالعه اضافه شد');
            } else if (response.data.action === 'removed') {
                setBookStatus(null);
                toast.success('کتاب از لیست مطالعه حذف شد');
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error('خطا در عملیات');
        } finally {
            setIsLoading(false);
        }
    };

    // تابع علامت زدن به عنوان خوانده شده
    const handleMarkAsCompleted = async () => {
        if (isLoading) return;
        setIsLoading(true);
        
        if (!currentUser) {
            toast.error('لطفاً ابتدا وارد شوید');
            window.location.href = '/login';
            return;
        }
        
        try {
            console.log("Marking as completed for book:", _id);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/user-book/completed`, {
                userId: currentUser._id,
                bookId: _id
            });
            
            console.log("Response:", response.data);
            
            if (response.data.action === 'completed') {
                setBookStatus('completed');
                toast.success('کتاب به لیست مطالعه شده اضافه شد');
            } else if (response.data.action === 'removed') {
                setBookStatus(null);
                toast.success('کتاب از لیست مطالعه شده حذف شد');
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error('خطا در عملیات');
        } finally {
            setIsLoading(false);
        }
    };

    let invalidImage = image_url;
    if (!invalidImage || invalidImage === "") {
        invalidImage = 'https://thecharulathapublications.com/wp-content/uploads/2022/11/book-placeholder.png';
    }

    let shortenedTitle = title;
    let shortenedAuthor = author;
    if (title && title.length > 25) shortenedTitle = title.substr(0, 25) + "...";
    if (author && author.length > 20) shortenedAuthor = author.substr(0, 20) + "...";

    // برای دیباگ - نمایش وضعیت در کنسول
    console.log("Rendering card for:", title, "Status:", bookStatus, "isAdmin:", isAdmin, "currentUser:", !!currentUser);

    return (
        <div className="col">
            <div className="card persian-book-card p-1 shadow">
                <div className="d-flex">
                    <div className="col-5 d-flex">
                        <Link to={`/read-persian/${_id}`}>
                            <img className="img-fluid rounded" style={{ height: '180px', objectFit: 'cover', width: '100%' }} src={invalidImage} alt="" />
                        </Link>
                    </div>
                    <div className="col-7 ps-2">
                        <div className="mb-2">
                            <h6 className="card-title">{shortenedTitle}</h6>
                            <p className="font-size-13 m-0 author-publication lh-1">{shortenedAuthor}</p>
                            {categories && categories.length > 0 && (
                                <div className="categories-container mt-1">
                                    {categories.slice(0, 2).map((cat, idx) => (
                                        <span key={idx} className="category-badge">{cat}</span>
                                    ))}
                                    {categories.length > 2 && <span className="category-badge more">+{categories.length - 2}</span>}
                                </div>
                            )}
                        </div>
                        <div className="d-flex gap-2 flex-wrap">
                            <Link to={`/read-persian/${_id}`} className="btn lh-1 btn-outline-success">مشاهده خلاصه</Link>
                            
                            {isAdmin && (
                                <>
                                    <Link to={`/edit-persian-book/${_id}`} className="btn lh-1 btn-outline-warning">ویرایش</Link>
                                    <button className="btn lh-1 btn-outline-danger" onClick={() => handleDelete(_id)}>حذف</button>
                                </>
                            )}
                            
                            {currentUser && !isAdmin && (
                                <div className="book-actions">
                                    {bookStatus === 'studying' && (
                                        <>
                                            <button className="btn lh-1 btn-outline-secondary" onClick={handleToggleStudying} disabled={isLoading}>
                                                📚 در حال مطالعه
                                            </button>
                                            <button className="btn lh-1 btn-outline-success" onClick={handleMarkAsCompleted} disabled={isLoading}>
                                                ✅ خواندم
                                            </button>
                                        </>
                                    )}
                                    {bookStatus === 'completed' && (
                                        <>
                                            <button className="btn lh-1 btn-outline-secondary" onClick={handleToggleStudying} disabled={isLoading}>
                                                📚 دوباره می‌خوانم
                                            </button>
                                            <button className="btn lh-1 btn-outline-success" disabled style={{ opacity: 0.6 }}>
                                                ✅ مطالعه شده
                                            </button>
                                        </>
                                    )}
                                    {!bookStatus && (
                                        <button className="btn lh-1 btn-outline-primary" onClick={handleToggleStudying} disabled={isLoading}>
                                            📚 می‌خواهم بخوانم
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PersianBookCard;